import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get } from 'lodash';

const cleanPhoneNumber = phoneNumber => phoneNumber.replace(/\D/g, '').replace(/^1/, '');

const HeaderFromQuote = ({
    logo, url, onClose, phoneNumber, altLogo,
}) =>
{
    const formTemplate = get(localStorage, 'formTemplate', 'default');

    return (
        <div className="tw-w-full">
            { (logo !== 'assets/img/image_placeholder.jpg' && logo)
                && (
                    <Link to={url} onClick={onClose}>
                        <div className="lg:tw-w-1/4 tw-mx-auto tw-mb-5">
                            <div className="list-square-item-image">
                                <img loading="lazy" src={logo} alt={altLogo} />
                            </div>
                        </div>
                    </Link>
                )
            }

            <a className="hover:tw-text-orange-400" href={`tel:${cleanPhoneNumber(phoneNumber) || '1 (844) 785-8575'}`}>
                <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal !tw-text-gray-700 leading-12 tw-pb-3">Call Now To Book</h2>
                <div className="tw-text-center tw-uppercase font-arapey tw-w-full tw-h-full tw-pb-5">
                    <span className="material-icons tw-align-middle tw-mr-2">phone</span>
                    <span className="font-lato font-lg xl:tw-inline">{phoneNumber || '1 (844) 785-8575'}</span>
                </div>
            </a>
            <div className="tw-w-full tw-pt-2 tw-pb-2 divider-container">
                <span className="font-lato">or</span>
            </div>
            <h2 className="font-arapey tw-text-3xl lg:tw-text-4xl tw-font-normal">
                Get a Quote {formTemplate === 'quote1' && 'from a Luxury Travel Advisor'}
            </h2>
        </div>
    );
};

HeaderFromQuote.propTypes = {
    logo: PropTypes.string,
    url: PropTypes.string,
    onClose: PropTypes.func,
    phoneNumber: PropTypes.string,
    altLogo: PropTypes.string,
};

export default HeaderFromQuote;
